import StatCard from "../../components/StatCard";
import Grid from "@mui/material/Grid2";
import { Box, Typography } from "@mui/material";
//demo data
import { data } from "../../data/data";
import { data2 } from "../../data/data";
//chart
import Chart1 from "../../components/chart/Chart1";
import Chart2 from "../../components/chart/Chart2";
import Chart3 from "../../components/chart/Chart3";
import RecentOrders from "../../components/recentOrders/RecentOrders";

export default function DashboardPage() {
  return (
    <>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(4) }}
      >
        {data2.map((card, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
            <StatCard {...card} />
          </Grid>
        ))}
      </Grid>

      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(1) }}
      >
        <Grid size={{ xs: 12, sm: 12, lg: 8 }}>
          <Box
            sx={{
              height: "400px",
              width: "100%",
              background: (theme) => theme.palette.background.paper,
              mb: (theme) => theme.spacing(3),
              boxShadow: "0px 8px 13px -3px rgba(0, 0, 0, 0.07)",
              pb: 6,
            }}
          >
            <Box sx={{ display: "flex" }}>
              <Box sx={{ display: "flex", alignItems: "center", pl: 4 }}>
                <Box
                  component="span"
                  sx={{
                    height: "1rem",
                    margin: "0.25rem",
                    width: "1rem",
                    border: "1px solid #32cd32", //42a5f5
                    padding: "3px 3px 1px",
                    borderRadius: "50%",
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      height: "9px",
                      width: "9px",
                      maxWidth: "10px",
                      bgcolor: "#32cd32",
                      borderRadius: "50%",
                      display: "block",
                    }}
                  ></Box>
                </Box>
                <Box>
                  <p>Donet</p>
                </Box>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", pl: 4 }}>
                <Box
                  component="span"
                  sx={{
                    height: "1rem",
                    margin: "0.25rem",
                    width: "1rem",
                    border: "1px solid #42a5f5", //42a5f5
                    padding: "3px 3px 1px",
                    borderRadius: "50%",
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      height: "9px",
                      width: "9px",
                      maxWidth: "10px",
                      bgcolor: "#42a5f5",
                      borderRadius: "50%",
                      display: "block",
                    }}
                  ></Box>
                </Box>
                <Box>
                  <p>Burger</p>
                </Box>
              </Box>
            </Box>
            <Chart1 data={data} />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, lg: 4 }}>
          <Box
            sx={{
              height: "400px",
              width: "100%",
              background: (theme) => theme.palette.background.paper,
              mb: (theme) => theme.spacing(3),
              boxShadow: "0px 8px 13px -3px rgba(0, 0, 0, 0.07)",
              pb: 5,
            }}
          >
            <Box>
              <Typography variant="h6" sx={{ pl: 4, pt: 1 }}>
                Profit by country
              </Typography>
            </Box>
            <Chart2 />
          </Box>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(3) }}
      >
        <Grid size={{ xs: 12, sm: 12, lg: 5 }}>
          <Box
            sx={{
              height: "400px",
              width: "100%",
              background: (theme) => theme.palette.background.paper,
              mb: (theme) => theme.spacing(3),
              boxShadow: "0px 8px 13px -3px rgba(0, 0, 0, 0.07)",
              pb: 5,
            }}
          >
            <Typography variant="h6" sx={{ pl: 4, pt: 2 }}>
              Sell by categories
            </Typography>
            <Chart3 />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, lg: 7 }}>
          <Box
            sx={{
              height: "400px",
              width: "100%",
              background: (theme) => theme.palette.background.paper,
              boxShadow: "0px 8px 13px -3px rgba(0, 0, 0, 0.07)",
            }}
          >
            <Box
              sx={{
                pl: 4,
                pt: 1,
                borderBottom: "1px solid var(--mui-palette-TableCell-border)",
                paddingBottom: "20px",
                marginBottom: "-24px",
                paddingTop: "10px",
              }}
            >
              <Typography variant="h6">Recent Orders</Typography>
            </Box>
            <Box sx={{ p: (theme) => theme.spacing(3) }}>
              <RecentOrders />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

//backgroundColor: "#ddeffd",
